module.exports = __webpack_public_path__ + "static/media/SM-ST-10.e67e0a82.mp3";